package com.neurobs.util

/** Processes log messages */
trait Logger {
	def log(s: String): Unit

	def debug(s: String): Unit

	def error(s: String): Unit

	def warn(s: String): Unit

	/** Logs comma-delimited list of object string representations using toString */
	def log(a1: Any, a: Any*): Unit = log(a.foldLeft(a1.toString)(_ + ", " + _.toString))
}

class NullLogger extends Logger {
	override def log(s: String): Unit = Unit

	override def debug(s: String): Unit = Unit

	override def error(s: String): Unit = Unit

	override def warn(s: String): Unit = Unit
}

/** Logger that prints messages using println with time and category prepended*/
class PrintLogger(printDebug: Boolean) extends Logger {
	override def log(s: String): Unit = print("log", s)

	override def debug(s: String): Unit = if (printDebug) print("debug", s)

	override def error(s: String): Unit = print("error", s)

	override def warn(s: String): Unit = print("warning", s)

	private def print(prefix: String, s: String): Unit = {
		println(s"$prefix : ${java.time.LocalTime.now(java.time.ZoneId.of("GMT"))} : $s")
	}
}